import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-contacts-edit',
  templateUrl: './campaign-contacts-edit.component.html',
  styleUrls: ['./campaign-contacts-edit.component.css']
})
export class CampaignContactsEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
